import CashAccountBankDetailsBase from './base/CashAccountBankDetailsBase';

/**
 * @class CashAccountBankDetails
 * @extends CashAccountBankDetailsBase
 */
class CashAccountBankDetails extends CashAccountBankDetailsBase {

}

export default CashAccountBankDetails;
